import React, { useState, useEffect, ChangeEvent } from 'react';
import { ReactSortable } from 'react-sortablejs';
import Spinner from '../components/ui/Spinner/Spinner';
import Button from 'react-bootstrap/Button';
import { RouteComponentProps, withRouter } from 'react-router';
import { API } from 'aws-amplify';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { startUpdatingPodcast, updatedPodcast } from '../redux/actions';
import { RootState } from '../redux/store';
import { connect } from 'react-redux';
import { fetchPodcasts, updatePodcast } from '../utils/api';
import { useForm } from 'react-hook-form';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface Props {
  error: boolean;
  message: string;
  loading: boolean;
}

interface DispatchProps {
  startUpdatingPodcast: () => void;
  updatedPodcast: (
    id: string,
    author: string,
    title: string,
    category: string,
    language: string,
    publisher: string,
    publicationLocation: string | undefined,
    publicationYear: string | undefined,
    description: string,
    type: string,
    parser: string,
    contentType: number,
    pollyLanguages: string,
    image: File | null,
    groups: string,
    retrieval: boolean,
    message: string,
    error: boolean,
    episodesOrderList: any | null,
  ) => {
    type: string;
    payload: {
      id: string;
      author: string;
      title: string;
      category: string;
      language: string;
      publisher: string;
      publicationLocation: string | undefined;
      publicationYear: string | undefined;
      description: string;
      type: string;
      parser: string;
      contentType: number;
      pollyLanguages: string;
      image: File | null;
      groups: string;
      retrieval: boolean;
      message: string;
      error: boolean;
      episodesOrderList: any | null;
    };
  };
}

type ComposedProps = Props & DispatchProps & RouteComponentProps<{ id: string }>;

const PodcastSort = (props: ComposedProps): JSX.Element => {
  const id = props.match.params.id;

  const { podcasts } = useAppSelector((state) => state.podcasts);
  const podcastDefaults = podcasts ? podcasts.filter((item: any) => item.id === id) : null;

  const [stateDnD, setStateDnD] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [episodes, setEpisodes] = useState<any[]>([]);
  const [filteredEpisodes, setFilteredEpisodes] = useState<any[]>([]);

  const dispatch = useAppDispatch();

  let voiceSettings;
  if (podcastDefaults[0]?.voiceSettings) {
    voiceSettings = JSON.parse(podcastDefaults[0].voiceSettings);
  } else {
    voiceSettings = {
      prosodyRate: 110,
      sampleRate: 24000,
      languages: {
        'en-US': { voiceId: 'Matthew', engine: 'neural', domain: 'empty' },
        'en-GB': { voiceId: 'Amy', engine: 'neural', domain: 'empty' },
        'ja-JP': { voiceId: 'Takumi', engine: 'standard', domain: 'empty' },
        'es-ES': { voiceId: 'Lucia', engine: 'neural', domain: 'empty' },
        'es-MX': { voiceId: 'Mia', engine: 'neural', domain: 'empty' },
        'es-US': { voiceId: 'Lupe', engine: 'neural', domain: 'news' },
      },
    };
  }

  const { handleSubmit } = useForm({
    defaultValues: {
      id: podcastDefaults ? podcastDefaults[0]?.id : null,
      author: podcastDefaults ? podcastDefaults[0]?.author : null,
      title: podcastDefaults ? podcastDefaults[0]?.title : null,
      category: podcastDefaults ? podcastDefaults[0]?.category : null,
      publisher: podcastDefaults ? podcastDefaults[0]?.publisher : null,
      publicationLocation: podcastDefaults ? podcastDefaults[0]?.publicationLocation : null,
      publicationYear: podcastDefaults ? podcastDefaults[0]?.publicationYear : null,
      description: podcastDefaults ? podcastDefaults[0]?.description : null,
      type: podcastDefaults ? podcastDefaults[0]?.type : 'serial',
      parser: podcastDefaults ? podcastDefaults[0]?.parser : 'Aquarius',
      contentType: podcastDefaults ? podcastDefaults[0]?.contentType : 1,
      language: podcastDefaults ? podcastDefaults[0]?.language : '',
      enGbVoiceId: voiceSettings.languages['en-GB']?.voiceId,
      enGbEngine: voiceSettings.languages['en-GB']?.engine,
      enGbDomain: voiceSettings.languages['en-GB']?.domain ? voiceSettings.languages['en-GB'].domain : 'empty',
      enUsVoiceId: voiceSettings.languages['en-US']?.voiceId,
      enUsEngine: voiceSettings.languages['en-US']?.engine,
      enUsDomain: voiceSettings.languages['en-US']?.domain ? voiceSettings.languages['en-US'].domain : 'empty',
      jaJpVoiceId: voiceSettings.languages['ja-JP']?.voiceId,
      jaJpEngine: voiceSettings.languages['ja-JP']?.engine,
      jaJpDomain: voiceSettings.languages['ja-JP']?.domain ? voiceSettings.languages['ja-JP'].domain : 'empty',
      esEsVoiceId: voiceSettings.languages['es-ES']?.voiceId ? voiceSettings.languages['es-ES'].voiceId : 'Lucia',
      esEsEngine: voiceSettings.languages['es-ES']?.engine ? voiceSettings.languages['es-ES'].engine : 'neural',
      esEsDomain: voiceSettings.languages['es-ES']?.domain ? voiceSettings.languages['es-ES'].domain : 'empty',
      esMxVoiceId: voiceSettings.languages['es-MX']?.voiceId ? voiceSettings.languages['es-MX'].voiceId : 'Mia',
      esMxEngine: voiceSettings.languages['es-MX']?.engine ? voiceSettings.languages['es-MX'].engine : 'neural',
      esMxDomain: voiceSettings.languages['es-MX']?.domain ? voiceSettings.languages['es-MX'].domain : 'empty',
      esUsVoiceId: voiceSettings.languages['es-US']?.voiceId ? voiceSettings.languages['es-US'].voiceId : 'Lupe',
      esUsEngine: voiceSettings.languages['es-US']?.engine ? voiceSettings.languages['es-US'].engine : 'neural',
      esUsDomain: voiceSettings.languages['es-US']?.domain ? voiceSettings.languages['es-US'].domain : 'empty',
      prosodyRate: voiceSettings.prosodyRate,
      episodesOrderList: podcastDefaults ? podcastDefaults[0]?.episodesOrderList : null,
      retrieval: podcastDefaults ? podcastDefaults[0]?.retrieval : false,
    },
  });

  const getEpisodes = async () => {
    setLoading(true);
    try {
      const apiName = 'Columbia';
      const path = `/podcast/`;

      const response = await API.get(apiName, path, 'abc');
      if (response) {
        let responseID = response.filter((item: any) => item.id === id);
        let responseIDEpisodesOrderList = responseID[0].episodesOrderList || [];
        setStateDnD(responseIDEpisodesOrderList);
        setEpisodes(responseIDEpisodesOrderList);
        setLoading(false);
      } else {
        setLoading(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(true);
    }
  };

  const alertVariant = error ? 'danger' : 'success';
  const alertMessage = error ? 'Failed to update order.' : 'Order updated.';
  useEffect(() => {
    if (podcastDefaults.length > 0) {
      let responseIDEpisodesOrderList = podcastDefaults[0].episodesOrderList || [];
      setStateDnD(responseIDEpisodesOrderList);
      setEpisodes(responseIDEpisodesOrderList);
      setLoading(false);
    } else {
      getEpisodes();
    }
  }, []);

  const onUpdate = async (data) => {
    const formData = new FormData();
    if (data.enGbDomain === 'empty') {
      data.enGbDomain = '';
    }

    if (data.enUsDomain === 'empty') {
      data.enUsDomain = '';
    }

    if (data.jaJpDomain === 'empty') {
      data.jaJpDomain = '';
    }
    const pollyLanguages = {
      languages: {
        'en-GB': {
          domain: data.enGbDomain,
          engine: data.enGbEngine,
          voiceId: data.enGbVoiceId,
        },
        'en-US': {
          domain: data.enUsDomain,
          engine: data.enUsEngine,
          voiceId: data.enUsVoiceId,
        },
        'ja-JP': {
          domain: data.jaJpDomain,
          engine: data.jaJpEngine,
          voiceId: data.jaJpVoiceId,
        },
      },
      prosodyRate: data.prosodyRate,
      sampleRate: 24000,
    };

    formData.append('id', podcastDefaults[0]?.id);
    formData.append('title', podcastDefaults[0]?.title);
    formData.append('category', podcastDefaults[0]?.category);
    formData.append('author', podcastDefaults[0]?.author);
    formData.append('publisher', podcastDefaults[0]?.publisher);
    formData.append('publicationLocation', data.publicationLocation);
    formData.append('publicationYear', data.publicationYear);
    formData.append('description', podcastDefaults[0]?.description);
    formData.append('type', podcastDefaults[0]?.type);
    formData.append('parser', podcastDefaults[0]?.parser);
    formData.append('contentType', podcastDefaults[0]?.contentType);
    formData.append('language', podcastDefaults[0]?.language);
    formData.append('pollyLanguages', JSON.stringify(pollyLanguages));
    formData.append('episodesOrderList', JSON.stringify(stateDnD));
    formData.append('retrieval', data.retrieval);
    //image is not updated and won't be send

    updatePodcast(data.id, formData)
      .then((response) => {
        props.updatedPodcast(
          podcastDefaults[0]?.id,
          podcastDefaults[0]?.title,
          podcastDefaults[0]?.category,
          podcastDefaults[0]?.author,
          podcastDefaults[0]?.language,
          podcastDefaults[0]?.publisher,
          podcastDefaults[0]?.publicationLocation,
          podcastDefaults[0]?.publicationYear,
          podcastDefaults[0]?.description,
          podcastDefaults[0]?.type,
          podcastDefaults[0]?.parser,
          podcastDefaults[0]?.contentType,
          podcastDefaults[0]?.pollyLanguages,
          podcastDefaults[0]?.image,
          podcastDefaults[0]?.groups,
          podcastDefaults[0]?.retrieval,
          'Started podcast update',
          false,
          stateDnD,
        );

        fetchPodcasts(dispatch);
        setShowAlert(true);
        setError(false);
      })
      .catch((error) => {
        props.updatedPodcast(
          podcastDefaults[0]?.id,
          podcastDefaults[0]?.title,
          podcastDefaults[0]?.category,
          podcastDefaults[0]?.author,
          podcastDefaults[0]?.language,
          podcastDefaults[0]?.publisher,
          podcastDefaults[0]?.publicationLocation,
          podcastDefaults[0]?.publicationYear,
          podcastDefaults[0]?.description,
          podcastDefaults[0]?.type,
          podcastDefaults[0]?.parser,
          podcastDefaults[0]?.contentType,
          podcastDefaults[0]?.pollyLanguages,
          podcastDefaults[0]?.image,
          podcastDefaults[0]?.groups,
          podcastDefaults[0]?.retrieval,
          'Failed to update podcast',
          true,
          stateDnD,
        );

        setShowAlert(true);
        console.log(error);
        setError(true);
      });
  };

  const onSubmitActionHandler = async (data) => {
    await onUpdate(data);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    if (value !== '') {
      const filteredItems = episodes.filter(
        (item) =>
          item.documentId.toLowerCase().includes(value.toLowerCase()) ||
          item.documentTitle.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredEpisodes(filteredItems);
    } else {
      setFilteredEpisodes([]);
    }
  };

  const resetSearch = () => {
    setSearchTerm('');
    setFilteredEpisodes([]);
  };

  return (
    <div className="col-8 episodesDnd">
      {showAlert && (
        <Alert variant={alertVariant} dismissible onClose={() => setShowAlert(false)}>
          {alertMessage}
        </Alert>
      )}
      <div className="d-flex w-50 custom-search-container">
        <input
          className="form-control"
          type="text"
          value={searchTerm}
          onChange={(event: ChangeEvent<HTMLInputElement>) => handleSearchChange(event.target.value)}
        />
        <Button className="custom-reset-search " variant="danger" onClick={resetSearch}>
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </div>
      <h5>Sortable List of Episodes</h5>
      <div className="two-column-container">
        <div className="column">
          <h6>Episode ID</h6>
        </div>
        <div className="column">
          <h6>Episode Title</h6>
        </div>
        <div className="column">
          <h6>State</h6>
        </div>
      </div>
      {loading ? (
        <Spinner height={300} width={300} color="#335153" />
      ) : (
        <form onSubmit={handleSubmit(onSubmitActionHandler)} encType="multipart/form-data">
          <ReactSortable
            style={{ paddingInlineStart: '0' }}
            tag="ul"
            animation={200}
            delay={1}
            list={stateDnD}
            setList={setStateDnD}
          >
            {stateDnD?.map((item) => (
              <li
                key={item.documentId}
                className="list-group-item"
                style={{
                  cursor: 'grab',
                  backgroundColor: filteredEpisodes.some((doc) => doc.documentId === item.documentId)
                    ? 'burlywood'
                    : 'white',
                }}
              >
                <div className="two-column-container">
                  <div className="column">{item.documentId}</div>
                  <div className="column">{item.documentTitle}</div>
                  <div className="column">{item.documentState}</div>
                </div>
              </li>
            ))}
          </ReactSortable>
          <Button variant="primary" type="submit">
            Submit Order
          </Button>
        </form>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    error: state.podcasts.error,
    message: state.podcasts.message,
    loading: state.podcasts.loading,
  };
};

const dispatchToProps: DispatchProps = {
  startUpdatingPodcast,
  updatedPodcast,
};

export default connect(mapStateToProps, dispatchToProps)(withRouter(PodcastSort));
